var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiereIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#425c77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "adobe-icon-svg",
    d: "M197.35,0H42.47C18.99,0,0,18.99,0,42.47v148.88C0,214.83,18.99,233.82,42.47,233.82h154.88c23.48,0,42.47-18.99,42.47-42.47V42.47C239.81,18.99,220.83,0,197.35,0ZM126.5,116.41c-4,5.6-9.59,9.79-16.09,12.19-6.79,2.5-14.29,3.4-22.48,3.4-2.4,0-4,0-5-.1-1-.1-2.4-.1-4.3-.1v32.07c.1.7-.4,1.3-1.1,1.4h-19.38c-.8,0-1.2-.4-1.2-1.3V61.15c0-.7.3-1.1,1-1.1,1.7,0,3.3,0,5.6-.1,2.4-.1,4.9-.1,7.59-.2,2.7-.1,5.6-.1,8.69-.2s6.1-.1,9.09-.1c8.19,0,14.99,1,20.58,3.1,5,1.7,9.59,4.5,13.39,8.19,3.2,3.2,5.7,7.09,7.29,11.39,1.5,4.2,2.3,8.49,2.3,12.99,0,8.59-2,15.69-6,21.28ZM194.65,84.93v19.48c0,.8-.5,1.1-1.6,1.1-3.6-.1-7.29.2-10.79,1-2.9.6-5.7,1.5-8.39,2.7-1.9.9-3.7,2.1-5.1,3.7v50.96c0,1-.4,1.4-1.3,1.4h-19.68c-.8.1-1.5-.4-1.6-1.2v-55.76c0-2.4,0-4.9-.1-7.49-.1-2.6-.1-5.2-.2-7.79,0-2.3-.2-4.5-.4-6.79-.1-.5.2-1,.7-1.1,0-.1.2-.1.3,0h0s17.49,0,17.49,0c1,0,1.8.7,2.1,1.6.3.8.5,1.6.6,2.5.2,1,.4,2.1.5,3.1.1,1.1.2,2.3.2,3.6,3-3.5,6.59-6.39,10.69-8.59,4.6-2.6,9.89-3.9,15.19-3.9.7-.1,1.3.4,1.4,1.1v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adobe-icon-svg",
    d: "M101.42,81.14c-3.7-1.5-7.69-2.1-11.79-2-2.6,0-4.9,0-6.79.1-2-.1-3.4,0-4.1.1h0v33.57c1.4.1,2.7.2,3.9.2h5.3c3.9,0,7.79-.6,11.49-1.8,3.2-.9,6-2.8,8.19-5.3,2.1-2.5,3.1-5.9,3.1-10.29.1-3.1-.7-6.2-2.3-8.89-1.7-2.6-4.1-4.6-6.99-5.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiereIcon);
export default __webpack_public_path__ + "static/media/premiere-icon.50351aa47cd8a7ac32313a624aa65872.svg";
export { ForwardRef as ReactComponent };